<template>
  <li class="c-headlinks__child-item">
    <a class="c-headlinks__child-link" :href="linkUrl" :class="linkingMode">
      {{ title }}
    </a>
  </li>
</template>

<script>
export default {
  name: "HeadlinkChildMenuItem",
  props: {
    title: String,
    linkUrl: String,
    linkingMode: String,
  },
  mounted() {
    this.id = this._uid;
  },
  data() {
    return {
      id: null,
      open: false,
    };
  },
  methods: {
    toggleOpen: function () {
      this.open = !this.open;
    },
  },
};
</script>
